
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Eye } from "lucide-react";
import { useEffect, useState } from "react";

interface StoryCircleProps {
  story: any;
  onSelect: () => void;
  isMobile?: boolean;
}

export const StoryCircle = ({ story, onSelect, isMobile }: StoryCircleProps) => {
  const { profiles: profile } = story;
  const [timeLeft, setTimeLeft] = useState(1); // 1 = fresh, 0 = expired

  useEffect(() => {
    const calculateTimeLeft = () => {
      const storyDate = new Date(story.created_at);
      const now = new Date();
      const hoursElapsed = (now.getTime() - storyDate.getTime()) / (1000 * 60 * 60);
      const timeLeftPercentage = Math.max(0, Math.min(1, (24 - hoursElapsed) / 24));
      setTimeLeft(timeLeftPercentage);
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 60000); // Update every minute
    return () => clearInterval(interval);
  }, [story.created_at]);

  const glowIntensity = Math.max(0.3, timeLeft); // Minimum intensity of 0.3
  const animationDuration = `${2 / glowIntensity}s`; // Animation gets slower as time passes

  return (
    <div className="relative group">
      <Button
        variant="ghost"
        className="p-0 h-auto"
        onClick={onSelect}
      >
        <div className="relative">
          <div 
            className="w-16 h-16 rounded-full p-0.5 bg-gradient-to-r from-[#00F0FF] to-[#0EA5E9] animate-pulse"
            style={{
              opacity: glowIntensity,
              animationDuration,
              background: `linear-gradient(45deg, 
                rgba(0, 240, 255, ${glowIntensity}), 
                rgba(14, 165, 233, ${glowIntensity * 0.8})
              )`
            }}
          >
            <Avatar className="w-full h-full">
              <AvatarImage src={profile?.avatar_url} />
              <AvatarFallback>{profile?.username?.[0]?.toUpperCase()}</AvatarFallback>
            </Avatar>
          </div>
          <div className={`absolute inset-0 rounded-full flex items-center justify-center bg-black/50 ${isMobile ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'} transition-opacity`}>
            <Eye className="w-5 h-5 text-white" />
          </div>
        </div>
      </Button>
      <span className="mt-1 text-xs text-center block truncate w-16">
        {profile?.username}
      </span>
    </div>
  );
};
